// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VdgO","colMin":"styles_colMin__20_Ju"};